export const SET_MAP_TRAILS_VISIBLE = 'SET_MAP_TRAILS_VISIBLE';

export const setMapTrailsVisible = visible => ({ type: SET_MAP_TRAILS_VISIBLE, payload: visible });
